module.exports = __webpack_public_path__ + "img/Anlyst_logo.4368cd4e.svg";